import { useEffect, useRef, useState } from "react";
import { Typography, Box, IconButton, Button } from "@mui/material";
import { UnControlled as CodeMirror } from "react-codemirror2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";

import "../codemirror.css";
import "codemirror/theme/oceanic-next.css";

require("codemirror/mode/javascript/javascript");

function RequestCode(props) {
  const editor = useRef();
  const wrapper = useRef();

  const [showMore, setShowMore] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [lines, setLines] = useState(0);

  const editorWillUnmount = () => {
    if (editor && wrapper?.current?.hydrated) {
      editor.current.display.wrapper.remove();
      wrapper.current.hydrated = false;
    }
  };

  const handleShowMore = () => {
    setShowMore((prevState) => !prevState);
  };

  useEffect(() => {
    const parentElement = document.querySelector(".request-codemirror");
    if (parentElement) {
      const childElement = parentElement.querySelector(".CodeMirror-scroll");
      if (childElement && showMore) {
        childElement.style.height = "100%"; // Change the height to your desired value
      }

      if (childElement && !showMore) {
        childElement.style.height = "215px"; // Change the height to your desired value
      }
    }
  }, [showMore]);

  useEffect(() => {
    if (props.code) {
      // const lines = props.code.split("\n").length;

      const jsonObject = JSON.parse(props.code);
      const prettyPrintedJSONString = JSON.stringify(jsonObject, null, 4);
      const jsonLines = prettyPrintedJSONString.split(/\r?\n/);

      setLines(jsonLines.length);
      const parentElement = document.querySelector(".request-codemirror");
      if (parentElement) {
        const childElement = parentElement.querySelector(".CodeMirror-scroll");
        if (childElement && jsonLines.length < 12) {
          childElement.style.height = "100%"; // Change the height to your desired value
        }
      }
    }
  }, [props.code]);

  return (
    <div
      style={{
        width: "100%",
        background: "rgb(38 50 56)",
        //padding: "10px 15px 19px 15px",
        borderRadius: "5px",
      }}
    >
      <Box
        className="codeBox-banner"
        sx={{ borderBottom: "1px solid rgb(255 255 255 / 20%)" }}
      >
        <Typography className="label-caps" sx={{ color: "#cfcfcf !important" }}>
          {props.type}
        </Typography>

        <IconButton
          onClick={() => props.copyFn(JSON.parse(props.code))}
          aria-label="delete"
          className="black-icon-button"
          size="small"
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Box>

      <CodeMirror
        className="request-codemirror"
        value={JSON.stringify(JSON.parse(props.code), null, 2)}
        ref={wrapper}
        options={{
          mode: { name: "javascript", json: true },
          theme: "oceanic-next",
          lineNumbers: true,
        }}
        editorDidMount={(e) => (editor.current = e)}
        editorWillUnmount={editorWillUnmount}
      />

      <Box
        className="codeBox-banner"
        sx={{ borderTop: "1px solid rgb(255 255 255 / 20%)" }}
        justifyContent="center"
      >
        <Button
          sx={{ visibility: lines > 12 ? "visible" : "hidden" }}
          onClick={handleShowMore}
          endIcon={!showMore ? <UnfoldMoreIcon /> : <UnfoldLessIcon />}
          className="show-more-btn-request"
          size="small"
        >
          Show {!showMore ? "more" : "less"}
        </Button>
      </Box>
    </div>
  );
}

export default RequestCode;
